// 261023 E3-P3h2 (H7) — tự mở Sổ duyệt khi máy viết xong (chuỗi «Truyện mới» chuyển sang DONE lúc người đang mở bàn làm việc). THUẦN, không antd/react.
// Một lần theo `run.id` (khoá ở sessionStorage, try/catch); chỉ khi chuyển trạng thái xảy ra trước mắt (mở trang khi đã DONE thì không kéo); không kéo người đang ở Sổ.
import type { AppendRun, AppendRunStatus } from '../../../types/adaptationWorkbench';

export const REVIEW_AUTO_KEY = (runId: string): string => `talebox.wb.reviewAutoOpened.${runId}`;

type StorageLike = Pick<Storage, 'getItem' | 'setItem'> | null | undefined;
export const reviewAutoOpened = (st: StorageLike, runId: string): boolean => {
  try { return st?.getItem(REVIEW_AUTO_KEY(runId)) === '1'; } catch { return false; }
};
export const markReviewAutoOpened = (st: StorageLike, runId: string): void => {
  try { st?.setItem(REVIEW_AUTO_KEY(runId), '1'); } catch { /* storage hỏng ⇒ chỉ mất khoá một-lần, không văng */ }
};

export interface AutoOpenInput {
  /** Trạng thái chuỗi ở lượt render trước (null/undefined = chưa thấy chuỗi nào ở phiên này). */
  prevStatus: AppendRunStatus | null | undefined;
  run: Pick<AppendRun, 'id' | 'kind' | 'status'> | null | undefined;
  /** Đang ở Sổ, hoặc đang đọc một tập từ Sổ (`from=review`). */
  atReview: boolean;
  hasWritten: boolean;
  alreadyOpened: boolean;
}

export const shouldAutoOpenReview = (i: AutoOpenInput): boolean => {
  const r = i.run;
  if (!r || r.kind !== 'NEW_STORY' || r.status !== 'DONE') return false;
  if (!i.prevStatus || i.prevStatus === 'DONE') return false;
  return !i.atReview && i.hasWritten && !i.alreadyOpened;
};
